import { render, staticRenderFns } from "./InicioComponent.vue?vue&type=template&id=804994f6&scoped=true"
import script from "./InicioComponent.vue?vue&type=script&lang=js"
export * from "./InicioComponent.vue?vue&type=script&lang=js"
import style0 from "./InicioComponent.vue?vue&type=style&index=0&id=804994f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804994f6",
  null
  
)

export default component.exports